import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

import {
    LineChart, Line,
    BarChart, Bar,
    PieChart, Pie, Cell,
    XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer
} from 'recharts';

// Import your CSS here
import '../styles/AnalyticsDashboard.css';

const COLORS = ['#0088FE', '#00C49F', '#FF8042'];

const AnalyticsDashboard = () => {
    const [salesData, setSalesData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [orderStatusData, setOrderStatusData] = useState([]);

    useEffect(() => {
        const API_BASE = getApiBaseUrl();
        axios.get(`${API_BASE}/api/dashboard-stats`)
            .then(res => {
                setSalesData(res.data.monthlySales);
                setUserData(res.data.userActivity);
                setOrderStatusData(res.data.orderStatus);
            })
            .catch(err => {
                console.error('Failed to fetch dashboard stats:', err);
            });
    }, []);

    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Analytics Dashboard</h2>

            {/* Line Chart */}
            <h3 className="dashboard-subtitle">Monthly Sales</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={salesData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="sales" stroke="#8884d8" />
                </LineChart>
            </ResponsiveContainer>

            {/* Bar Chart */}
            <h3 className="dashboard-subtitle">User Activity</h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={userData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="users" fill="#82ca9d" />
                </BarChart>
            </ResponsiveContainer>

            {/* Pie Chart */}
            <h3 className="dashboard-subtitle">Order Status Distribution</h3>
            <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                    <Pie
                        data={orderStatusData}
                        dataKey="count"
                        nameKey="status"
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        fill="#8884d8"
                        label
                    >
                        {orderStatusData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AnalyticsDashboard;
